//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormatPrice from '@/elements/price/format-price.vue'

import RbBaseWishlist from '@/elements/miniwishlist/base-wishlist.vue'
import { mapGetters } from 'vuex'
import wcs from '@/scripts/libs/wcs'

export default {
  name: 'rb-header-wishlist',
  components: {
    FormatPrice,
  },
  extends: RbBaseWishlist,
  computed: {
    ...mapGetters['storeConfig'],
    linkSunglasses() {
      return wcs.getEndPoint('sunglassesURL')
    },
    linkOptics() {
      return wcs.getEndPoint('eyeglassesURL')
    },
  },
}
